module.exports = __webpack_public_path__ + "static/media/cards-team-back.770570d7.webp";